import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { formatCurrency, formatNumber } from '../../utils/formatters';
import CustomTooltip, { TooltipSection } from '../cards/subcomponents/CustomTooltip';
import { IAssetData } from '../../shared/types';

interface AssetRowProps extends IAssetData {
  percentage: number;
  index: number;
}

const AssetRow: React.FC<AssetRowProps> = ({
  symbol,
  valueUSD,
  amount,
  percentage,
  color,
}) => {
  const tooltipSections: TooltipSection[] = [
    {
      title: `${symbol} Details`,
      items: [
        { label: 'Amount', value: `${formatNumber(amount, 2)} ${symbol}` },
        { label: 'Value',  value: formatCurrency(valueUSD) }
      ]
    }
  ];

  return (
    <CustomTooltip sections={tooltipSections} placement="top" accentColor="secondary.main" fullWidth disableOnTouch>
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ width: '100%', cursor: 'help' }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ width: 76, flexShrink: 0 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '2px', bgcolor: color, flexShrink: 0 }} />
          <Typography sx={{ fontSize: '0.8125rem', fontWeight: 600 }} noWrap>{symbol}</Typography>
        </Stack>

        <Box sx={{ flexGrow: 1, height: 6, bgcolor: 'rgba(255,255,255,0.07)', borderRadius: 3, overflow: 'hidden' }}>
          <Box
            sx={{
              height: '100%',
              width: `${percentage}%`,
              bgcolor: color,
              borderRadius: 3,
              transition: 'width 0.3s ease-out',
            }}
          />
        </Box>

        <Typography
          sx={{ fontSize: '0.8125rem', fontWeight: 600, minWidth: 48, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}
        >
          {percentage.toFixed(1)}%
        </Typography>
      </Stack>
    </CustomTooltip>
  );
};

export default AssetRow;
